import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

function FontManager() {
  const {i18n} = useTranslation();

  useEffect(() => {
    const handleLanguageChange = () => {
      const currentLanguage = i18n.language;
      // const isArabic = currentLanguage === 'ar';
      const arabicFontFamily = 'Tajawal, sans-serif'; // Adjust font name
      document.documentElement.style.setProperty(
        '--default-font-family',
        currentLanguage === 'ar'
          ? arabicFontFamily
          : '-apple-system, BlinkMacSystemFont, avenir next, avenir, helvetica neue, helvetica, Ubuntu, roboto, noto, segoe ui, arial, sans-serif',
      );
      // document.documentElement.dir = isArabic ? 'rtl' : 'ltr';
    };

    i18n.on('languageChanged', handleLanguageChange);
    handleLanguageChange(); // Initial setup

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  return null; // Renders nothing
}

export default FontManager;
